import { render, staticRenderFns } from "./ErrorMixin.js.vue?vue&type=template&id=0a1174a0&scoped=true&"
import script from "./ErrorMixin.js.vue?vue&type=script&lang=js&"
export * from "./ErrorMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1174a0",
  null
  
)

export default component.exports